export default __webpack_public_path__ + "static/media/i001vp.2509503e.webp";